module.exports = "/currency/assets/8f9258df9c7266608ce890f13679d015.png";